import {ServiceMethodOptions} from "./PagingController";


export const paginatedRequestQuery = (options: ServiceMethodOptions) => ({
    "page[number]": options.page,
    "page[size]": options.perPage,
});